import Agilite from 'agilite'
import store from '../../../../../../../store'
import { handleError } from '../../../../../../lib/errorHandler'

const agilite = new Agilite({
  apiServerUrl: process.env.REACT_APP_AGILITE_API_URL,
  apiKey: process.env.REACT_APP_AGILITE_API_KEY
})

export const readAssessmentTemplates = (filter) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        let response = null
        response = await agilite.Connectors.execute('assessment_templating', 'read', {
          filter: JSON.stringify(filter)
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const createAssessmentTemplate = (data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        let response = null
        const userRef = store.getState().auth.agiliteUser._id

        response = await agilite.Connectors.execute('assessment_templating', 'create', {
          data: JSON.stringify({ userRef, ...data })
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const updateAssessmentTemplate = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        let response = null
        const modifiedAt = new Date()
        const modifiedBy = store.getState().auth.agiliteUser._id

        response = await agilite.Connectors.execute('assessment_templating', 'update', {
          recordId,
          data: JSON.stringify(data)
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const assessmentTemplateRecordCreate = (data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        let response = null
        const userRef = store.getState().auth.agiliteUser._id
        const createdAt = new Date()

        response = await agilite.Connectors.execute('assessment_templates_records', 'create', {
          data: JSON.stringify({
            ...data,
            userRef,
            createdAt,
            createdBy: userRef,
            modifiedAt: createdAt,
            modifiedBy: userRef,
            status: data.status || 'draft',
            isActive: true
          })
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const assessmentTemplateRecordsRead = (filter) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        let response = null

        response = await agilite.Connectors.execute('assessment_templates_records', 'read', {
          filter: JSON.stringify(filter)
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}

export const assessmentTemplateRecordUpdate = (recordId, data) => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      try {
        let response = null
        const userRef = store.getState().auth.agiliteUser._id
        const modifiedAt = new Date()

        response = await agilite.Connectors.execute('assessment_templates_records', 'update', {
          recordId,
          data: JSON.stringify({
            ...data,
            modifiedAt,
            modifiedBy: userRef
          })
        })
        resolve(response.data)
      } catch (e) {
        reject(handleError(e, true))
      }
    })()
  })
}
